import React from 'react';
import {
  HeadContent,
  Outlet,
} from '@tanstack/react-router';
import { GoogleAnalytics } from 'tanstack-router-ga4';
import { Toaster } from 'sonner';

import { loadUserProfile } from './api/Auth';

import Header from './components/Header';
import ShareModal from './components/ShareModal';

const App: React.FC = () => {
  loadUserProfile();

  return (
    <div className="app-container">
      <div className="dropzone-overlay">
        <h2>Drop files to upload</h2>
      </div>
      <HeadContent />
      <GoogleAnalytics measurementId={import.meta.env.VITE_GA_MEASUREMENT_ID} />
      <Header />
      <Outlet />
      <Toaster position="top-right" />
      <ShareModal  />
    </div>
  );
}

export default App;
